module.exports = __webpack_public_path__ + "media/application/images/svgs/bar-chart-2-67e0c80f40086694a0f5947f2fb94486.svg";